import { useId } from "react";
import type { QuestionProps } from "../types";
import { choiceInput, choiceRow } from "./choiceStyles";
import { QuestionShell } from "./QuestionShell";

export function SingleChoice(props: QuestionProps) {
  const id = useId();
  const { question, value, onChange, disabled } = props;
  return (
    <QuestionShell props={props} inputId={id} asGroup>
      {({ labelId, helpId }) => (
        <div role="radiogroup" aria-labelledby={labelId} aria-describedby={helpId} className="flex flex-col gap-2">
          {(question.options ?? []).map((o) => (
            <label key={o.value} className={choiceRow}>
              <input
                type="radio"
                className={choiceInput}
                name={`${id}-${question.id}`}
                value={o.value}
                checked={value === o.value}
                disabled={disabled}
                onChange={() => onChange(o.value)}
              />
              <span className="flex flex-col">
                <span>{o.label}</span>
                {o.help ? <span className="text-sm text-fg-muted">{o.help}</span> : null}
              </span>
            </label>
          ))}
        </div>
      )}
    </QuestionShell>
  );
}
